var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Popover } from 'react-tiny-popover';
import styled, { css } from 'styled-components';
export var CustomPopover = function (props) {
    useEffect(function () {
        var handleKey = function (e) {
            if (e.key === 'Escape')
                props.onOuterAction();
        };
        if (props.onOuterAction) {
            document.addEventListener('scroll', props.onOuterAction);
        }
        document.addEventListener('keydown', handleKey);
        return function () {
            if (props.onOuterAction) {
                document.removeEventListener('scroll', props.onOuterAction);
            }
            document.removeEventListener('keydown', handleKey);
        };
    }, [props]);
    var body = props.body, bgColor = props.bgColor, 
    // tipSize,
    borderColor = props.borderColor, onOuterAction = props.onOuterAction, 
    // preferPlace,
    // place,
    isOpen = props.isOpen, 
    // offset,
    children = props.children, borderRadius = props.borderRadius, bodyStyle = props.bodyStyle, 
    // popoverStyle,
    bodyRef = props.bodyRef;
    return (_jsx(Popover, __assign({ content: _jsx("div", __assign({ ref: bodyRef, style: __assign({ background: bgColor, border: "1px solid ".concat(borderColor), borderRadius: borderRadius, boxSizing: 'content-box' }, bodyStyle) }, { children: body })), onClickOutside: onOuterAction, isOpen: isOpen }, { children: children })));
};
export default CustomPopover;
